import React from "react";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { useHistory } from "react-router-dom";
import { useHttpClient } from "../hooks/http-hook";

const MyApp = (props) => {
  const history = useHistory();
  const { error, sendRequest } = useHttpClient();

  const updateProducts = async () => {
    try {
      await sendRequest(
        process.env.REACT_APP_PURCHASE,
        "PATCH",
        JSON.stringify({ cart: props.cart }),
        {
          "Content-type": "application/json",
        }
      );
    } catch (err) {}
  };

  let env = "sandbox";
  let currency = "USD";
  const client = {
    sandbox: process.env.REACT_APP_APPID,
    production: "YOUR-PRODUCTION-APP-ID",
  };
  const onSuccess = (payment) => {
    console.log("The payment was succeeded!", payment);
    props.clearCart();
    updateProducts();
    error &&
      alert(
        "there was a problem in updating the backend. As a result the payment made will be returned back."
      );
    history.push("/purchasesuccess");
  };

  const onCancel = (data) => {
    history.push("/purchasefail");
  };

  const onError = (err) => {
    history.push("/purchasefail");
  };
  return (
    <PaypalExpressBtn
      env={env}
      client={client}
      currency={currency}
      total={props.total}
      onError={onError}
      onSuccess={onSuccess}
      onCancel={onCancel}
    />
  );
};

export default MyApp;
